import "./Work.css";
import {
  Ctabanner,
  Footer,
  WorkIndividual,
  Nav,
  WorkIndividual1
} from "../../Components/ExportComponents";
import { useState } from "react";

import top1 from "../../Images/Academy/top1.png";
import top2 from "../../Images/Academy/top2.png";

import academy1 from "../../Images/Academy/academy1.png";
import academy2 from "../../Images/Academy/academy2.png";
import academy3 from "../../Images/Academy/academy3.png";
import academy4 from "../../Images/Academy/academy4.png";

import p1 from "../../Images/pokhara/1.jpg";
import p2 from "../../Images/pokhara/2.jpg";

import pkr3 from "../../Images/pokhara/3.jpg";
import pkr4 from "../../Images/pokhara/4.jpg";
import pkr5 from "../../Images/pokhara/5.jpg";
import pkr6 from "../../Images/pokhara/6.jpg";

import { Helmet } from "react-helmet"; // ✅ Added Helmet

const Work = () => {
  const [menuBar, setMenuBar] = useState(false);

  return (
    <div className="backgroundBig">
      {/* Page-specific SEO */}
      <Helmet>
        <title>Design Portfolio & UI/UX Projects | The Visual Designer Nepal</title>
        <meta name="description" content="Explore graphic design, UI/UX design, branding, and digital marketing projects by The Visual Designer from Pokhara, Nepal." />

        {/* Open Graph */}
        <meta property="og:title" content="Design Portfolio & UI/UX Projects | The Visual Designer Nepal" />
        <meta property="og:description" content="Explore graphic design, UI/UX design, branding, and digital marketing projects by The Visual Designer from Pokhara, Nepal." />
        <meta property="og:image" content="https://thevisualdesigner.co/static/media/authorBig.png" />
        <meta property="og:url" content="https://thevisualdesigner.co/work" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Design Portfolio & UI/UX Projects | The Visual Designer Nepal" />
        <meta name="twitter:description" content="Explore graphic design, UI/UX design, branding, and digital marketing projects by The Visual Designer from Pokhara, Nepal." />
        <meta name="twitter:image" content="https://thevisualdesigner.co/static/media/authorBig.png" />

        {/* Canonical */}
        <link rel="canonical" href="https://thevisualdesigner.co/work" />
      </Helmet>

      <span className="mainBackgroundHR"></span>
      <span className="mainBackgroundHRleft"></span>
      <div className="mainBackgroundHRRight"></div>
      <span className="mainBackgroundHRright"></span>
      <span className="mainBackgroundBig"></span>
      <span className="mainBackgroundBigRight"></span>

      <div className="smallBack">
        <div className="topLeftInternal"></div>
          <div className="topLeftInternal2"></div>

          <div className="topRightInternal"></div>
          <div className="topRightInternal2"></div>
        <Nav setMenuBar={setMenuBar} menuBar={menuBar} />

        <div className="workPage">
          <div className="textInroduction">
            <div className="titleNdecsFr">
              <div className="titleHeadline">Work</div>
              <div className="titleDesc">Latest Creative Portfolio</div>
            </div>

            <div className="titleOfBlogP">
              A collection of experience-backed content that breaks down design
              principles, brand strategy, digital trends, and creative workflows
            </div>
          </div>

          <div className="listWorks">
            <WorkIndividual title={"Scaleup Academy"} desc={"A refined look at the visual identities, interfaces, and marketing assets I’ve designed for brands locally and globally."} top1={top1} top2={top2} academy1={academy1} academy2={academy2} academy3={academy3} academy4={academy4} hello={true} />
            <WorkIndividual title={"Pokhara Internet"} desc={"A refined look at the visual identities, interfaces, and marketing assets I’ve designed for brands locally and globally."} top1={p1} top2={p2} academy1={pkr3} academy2={pkr4} academy3={pkr5} academy4={pkr6} />
          </div>

          <Ctabanner />
          
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Work;
